import type { ReactNode } from "react";

/** A quiet empty/error state: serif title, one line of reassurance, optional action. */
export function Calm({
  title,
  body,
  children,
}: {
  title: string;
  body: string;
  children?: ReactNode;
}) {
  return (
    <div className="flex flex-col items-center gap-2 px-6 py-14 text-center">
      <p className="font-serif text-2xl text-ink">{title}</p>
      <p className="max-w-sm text-muted">{body}</p>
      {children ? <div className="mt-2">{children}</div> : null}
    </div>
  );
}
